import api from "./api";

const route = "/reproducciones";

export default {
  playLeccion: () => api.get(route),
  terminarReproduccion: (idLeccion) => api.put(route, { idLeccion }),
};
